(function () {
  // Extra safety: do nothing unless we are on the cart page
  if (!location.pathname.match(/^\/cart(\/)?$/)) return;

  const root = document.getElementById('MainContent') || document.documentElement;

  function setStateFromCartItems() {
    const cartItems = document.querySelector('cart-items');
    if (!cartItems) return;

    const empty = cartItems.classList.contains('is-empty');
    root.classList.toggle('cart-empty', empty);
    root.classList.toggle('cart-not-empty', !empty);
  }

  function observeCartItems() {
    const cartItems = document.querySelector('cart-items');
    if (!cartItems) return;

    new MutationObserver(setStateFromCartItems).observe(cartItems, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setStateFromCartItems();
      observeCartItems();
    });
  } else {
    setStateFromCartItems();
    observeCartItems();
  }

  let attempts = 0;
  const interval = setInterval(() => {
    attempts += 1;
    setStateFromCartItems();
    observeCartItems();
    if (attempts >= 10) clearInterval(interval);
  }, 500);
})();
